import { Component, Inject, Input, OnInit } from '@angular/core';
import { MaxBrainNavigation } from 'app/navigation/maxbrain-navigation';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { MAXBRAIN_NAVIGATION } from 'app/services/navigation.token';

@Component({
    selector: 'app-navigation-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    animations: fuseAnimations,
})
export class MaxBrainNavigationItemComponent implements OnInit {
    @Input()
    itemId: string;

    navigationItem: MaxBrainNavigation;

    constructor(@Inject(MAXBRAIN_NAVIGATION) private _navigation: MaxBrainNavigation[]) {}

    ngOnInit(): void {
        this.navigationItem = this._navigation.find((item) => item.id === this.itemId);
    }
}
